import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.PRODUCT_BATCH_CODE_LIST:
    case actions.PRODUCT_BATCH_CODE_INFO_LIST:
      return {
        ...state,
        isSearching: true,
      };
    case actions.PRODUCT_BATCH_CODE_LIST_ENDED:
    case actions.PRODUCT_BATCH_CODE_INFO_LIST_ENDED:
      return {
        ...state,
        isSearching: false,
      };

    case actions.CREATE_PRODUCT_BATCH_CODE:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_PRODUCT_BATCH_CODE_ENDED:
      return {
        ...state,
        isCreating: false,
      };

    case actions.PUT_PRODUCT_BATCH_CODE:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.PUT_PRODUCT_BATCH_CODE_ENDED:
      return {
        ...state,
        isUpdating: false,
      };

    case actions.DELETE_PRODUCT_BATCH_CODE:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_PRODUCT_BATCH_CODE_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
